import {useContext, useState} from 'react';
import {useFormik} from 'formik';
import {ThemeContext} from 'styled-components';
import {API_PATCH_TOURISTIC_SITE} from '../../../utils/api';
import touristicSiteSchema from '../../_schemas/touristic_site_schema';
import {TextArea, TextInput, Form} from '../../../_ui/_v2/components/FormElements';
import Button from '../../../_ui/_v2/components/Button';
import Loader from '../../../_ui/_v2/components/Loader';
import TouristicSiteContext from '../../../_contexts/TouristicSiteContext';
import {useTranslation} from "react-i18next";

const touristicSiteSchemaForTouristicSiteAmbassadorReviewForm = touristicSiteSchema.pick([
  'ambassador_review',
]);

const TouristicSiteAmbassadorReviewForm = ({onSuccess, touristicSite = {}}) => {
  const theme = useContext(ThemeContext);
  const [loading, setLoading] = useState(false);
  const { setTouristicSite } = useContext(TouristicSiteContext);
  const {i18n} = useTranslation(["touristic-site"]);

  const reviewKey = `ambassador_review[text_${i18n.language}]`;

  const handleSubmitForm = (values, actions) => {
    const token = localStorage.getItem("Authorization");

    setLoading(true);
    fetch(
      API_PATCH_TOURISTIC_SITE(touristicSite.id),
      {
        method: 'PATCH',
        cache: 'default',
        body: JSON.stringify(values),
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        mode: 'cors',
      }
    )
      .then(res => res.json())
      .then(response => {
        setTouristicSite(response);
        // setLoading(false);
        onSuccess?.(response);
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
      });
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: touristicSiteSchemaForTouristicSiteAmbassadorReviewForm.cast(touristicSite),
    validationSchema: touristicSiteSchemaForTouristicSiteAmbassadorReviewForm,
    onSubmit: handleSubmitForm,
  });

  return (
    <Form onSubmit={handleSubmit}>
      <TextArea
        name={`ambassador_review[text_${i18n.language}]`}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.ambassador_review?.[`text_${i18n.language}`] || ''}
        hasError={errors.ambassador_review?.[`text_${i18n.language}`] && touched.ambassador_review?.[`text_${i18n.language}`]}
        errorMessage={errors.ambassador_review?.[`text_${i18n.language}`]}
        placeholder={'Avis'}
        rows="10"
      />
      <Button
        rounded
        disabled={loading}
        type="submit"
        style={{
          display: 'block',
          margin: '3em auto 0 auto',
        }}
      >
        {
          loading
            ? <Loader size="1.5em" color={theme.colors.white}/>
            : 'Enregistrer'
        }
      </Button>
    </Form>
  );
};

export default TouristicSiteAmbassadorReviewForm;
